import axios from 'axios';

import NewsDetailsModel from './news-details.model.js';

class NewsService {
	getNewsDetailsBySlug(lang, slug) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/collections/get/news?lang=${lang}&filter[slug]=${slug}`,
			)
			.then(({ data }) => {
				if (data.entries.length === 0) {
					return Promise.reject();
				}
				return new NewsDetailsModel(data.entries[0]);
			})
			.catch(error => Promise.reject(error));
	}

	getRelatedNews(lang, category, limit = 3) {
		return axios
			.post(`${process.env.REACT_APP_API_ENDPOINT}/api/collections/get/news`, {
				lang,
				sort: {
					date: -1,
				},
				filter: {
					category,
				},
				limit,
			})
			.then(({ data }) => data.entries.map(entry => new NewsDetailsModel(entry)));
	}

	getNews({ lang, limit, skip }) {
		return axios
			.post(`${process.env.REACT_APP_API_ENDPOINT}/api/collections/get/news`, {
				lang,
				sort: {
					date: -1,
				},
				limit,
				skip,
			})
			.then(({ data }) => ({
				data: data.entries.map(entry => new NewsDetailsModel(entry)),
				total: data.total,
			}));
	}
}

export default new NewsService();
